import React from 'react';
import { BrowserRouter, Routes, Route, Navigate } from 'react-router-dom';
import { AuthProvider, useAuth } from './AuthContext';
import GlobalErrorModal from './components/GlobalErrorModal';
import StudentSyncIssueMonitor from './components/StudentSyncIssueMonitor';
import AttendeeSaveErrorMonitor from './components/AttendeeSaveErrorMonitor';
import Login from './pages/Login';
import Dashboard from './pages/Dashboard';
import ExternalForm from './pages/ExternalForm';
import CertificateLookupPublic from './pages/CertificateLookupPublic';
import ActivateAccount from './pages/ActivateAccount';

function PrivateRoute({ children }) {
  const { token, isInitializing } = useAuth();
  if (isInitializing) return null;
  return token ? children : <Navigate to="/" />;
}

export default function App() {
  return (
    <AuthProvider>
      <BrowserRouter>
        <GlobalErrorModal />
        <StudentSyncIssueMonitor />
        <AttendeeSaveErrorMonitor />
        <Routes>
          <Route path="/" element={<Login />} />
          <Route path="/login" element={<Navigate to="/" replace />} />
          <Route path="/activate" element={<ActivateAccount />} />
          <Route path="/formularios/:token" element={<ExternalForm />} />
          <Route path="/tarefas-externas/:token" element={<ExternalForm />} />
          <Route
            path="/certificados/consulta"
            element={<CertificateLookupPublic />}
          />
          <Route
            path="/dashboard"
            element={
              <PrivateRoute>
                <Dashboard />
              </PrivateRoute>
            }
          />
          <Route path="*" element={<Navigate to="/dashboard" />} />
        </Routes>
      </BrowserRouter>
    </AuthProvider>
  );
}
